import * as Scrivito from "scrivito";

export function isLiv(obj) {
  const page = obj || Scrivito.currentPage();
  return (
    page?.siteId() === "62854995310d1623" ||
    page?.siteId() === "8d9b3a5d4cd769ec"
  );
}

export function isIntranet(obj) {
  const page = obj || Scrivito.currentPage();
  return page?.siteId() === "intranet";
}
